import { render, staticRenderFns } from "./AssistantChatDrawer.vue?vue&type=template&id=f610e8de&scoped=true"
import script from "./AssistantChatDrawer.vue?vue&type=script&lang=js"
export * from "./AssistantChatDrawer.vue?vue&type=script&lang=js"
import style0 from "./AssistantChatDrawer.vue?vue&type=style&index=0&id=f610e8de&prod&scoped=true&lang=css"
import style1 from "./AssistantChatDrawer.vue?vue&type=style&index=1&id=f610e8de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f610e8de",
  null
  
)

export default component.exports